module.exports = __webpack_public_path__ + "static/media/seven.dcba4e7b.svg";